import React, { Component } from 'react'
import cx from 'classnames'
import za from 'za-helper'
import { ZAEnv, ZARef } from 'za-react'
import Button from '~/components/Button'
import { platform, universalOpenUrl } from '~/utils'
import styles from './index.css'

export default class Download extends Component {
  zaRef = React.createRef()
  handleClick = () => {
    try {
      za.trackEvent(this, { id: 2047 })
      // eslint-disable-next-line no-unused-expressions
      this.zaRef.current.trackEvent({
        eventType: 'Click',
        action: 'OpenUrl',
        elementLocation: { type: 'Button' },
      })
    } catch (e) {
      console.error(e)
    }

    const { landPageIOS, landPageAndroid } = this.props
    const landPage = platform === 'ios' ? landPageIOS : landPageAndroid
    universalOpenUrl(landPage)
  }

  render() {
    const {
      className,
      productImgUrl,
      productMainTitle,
      productViceTitle,
    } = this.props

    return (
      <div className={cx(styles.download, className)}>
        <div className={styles.downloadInfo}>
          <img src={productImgUrl} alt="" className={styles.downloadImage} />
          <div className={styles.downloadDesc}>
            <header className={styles.downloadTitle}>{productMainTitle}</header>
            <span className={styles.downloadSubtitle}>{productViceTitle}</span>
          </div>
        </div>
        <ZAEnv block="activityCardButton">
          <ZARef ref={this.zaRef} />
          <Button onClick={this.handleClick}>点击下载</Button>
        </ZAEnv>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Conversion/DownLoad/index.js